import React, { FC, useCallback } from 'react';
import { SEARCH_STRING_LOCALIZATION_KEY } from '@next/shared';
import { useLocalizationContext } from 'shared/lib/localization';
import { StyledSignInButton } from './styled';

interface SignInProps {
    signInUrl: string;
    testId: string;
}

export const SignIn: FC<SignInProps> = ({ signInUrl, testId }) => {
    const { language } = useLocalizationContext();

    const redirectToSignIn = useCallback(() => {
        window.location.href = `${signInUrl}?${SEARCH_STRING_LOCALIZATION_KEY}=${language}`;
    }, [signInUrl, language]);

    return (
        <StyledSignInButton
            localizationKey="Landing.Unauthenticated_LogInLinkCaption"
            mode="secondary"
            size="large"
            testId={testId}
            onClick={redirectToSignIn}
        />
    );
};
